gsap.to('.main__bg-image:nth-of-type(1)',{opacity: 0,duration: 1,
  scrollTrigger:{
    trigger:'.section--evening',
    start:'top 40%',
    end:'bottom 20%',
    toggleActions:'play none none reverse',
  }});

gsap.to('.top-message',{opacity: 0,duration: 0.3,
  scrollTrigger:{
    trigger:'.section--rantan',
    start:'top 40%',
    end:'bottom 20%',
    toggleActions:'play none none reverse',
  }});

gsap.fromTo('.section__message--rantan',{
  opacity: 0,
  y: 20
},{opacity: 1,
  y: 0,duration: .5,
  scrollTrigger:{
    trigger:'.section--rantan',
    start:'top 20%',
    end:'bottom 20%',
    toggleActions:'play none none reverse',
  }});
